import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";

import accountSlice from "../features/account/accountSlice";
import advancePaymentSlice from "../features/advancePayment/advancePaymentSlice";
import announcementSlice from "../features/announcement/announcementSlice";
import AssetsSlice from "../features/assets/assetsSlice";
import attendanceReducer from "../features/attendance/attendanceSlice";
import awardSlice from "../features/award/awardSlice";
import awardHistorySlice from "../features/awardHistory/awardHistorySlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import dayPartSlice from "../features/dayPartSchedule/dayPartSlice";
import designationReducer from "../features/designation/designationSlice";
import documentSlice from "../features/document/documentSlice";
import employeeDocumentSlice from "../features/employeeDocument/employeeDocumentSlice";
import employmentStatusSlice from "../features/employemntStatus/employmentStatusSlice";
import expenseSlice from "../features/expense/expenseSlice";
import expenseTypeSlice from "../features/expense/expenseTypeSlice";
import expenseProjectSlice from "../features/expenseProject/expenseProjectSlice";
import leaveSlice from "../features/leave/leaveSlice";
import leavePolicySlice from "../features/leavePolicy/leavePolicySlice";
import linkUserSlice from "../features/linkUser/linkUserSlice";
import loanSlice from "../features/loan/loanSlice";
import terminationReasonSlice from "../features/masters/terminationReasonSlice";
import paymentSlice from "../features/payment/paymentSlice";
import payrollSlice from "../features/payroll/payrollSlice";
import AssignedTaskSlice from "../features/projectManagement/project/assignedTask/assignedTask";
import milestoneSlice from "../features/projectManagement/project/milestone/milestone";
import projectSlice from "../features/projectManagement/project/project/project";
import notificationSlice from "../features/notification/notificationSlice";
import projectTaskSlice from "../features/projectManagement/project/projectTask/projectTask";
import projectTeamSlice from "../features/projectManagement/project/projectTeam/projectTeam";
import projectSiteDetailsSlice from "../features/projectManagement/project/projectSite/projectSiteDetails";
import projectSiteAreaSlice from "../features/projectManagement/project/projectSite/projectSiteArea";
import projectWBSSlice from "../features/projectManagement/project/projectWBS/projectWBS";
import projectTypeSlice from "../features/projectManagement/project/projectType/projectType";
import taskDependencySlice from "../features/projectManagement/project/taskDependency/taskDependency";
import taskPrioritySlice from "../features/projectManagement/project/taskPriority/taskPriority";
import taskStatusSlice from "../features/projectManagement/project/taskStatus/taskStatus";
import taskTimeSlice from "../features/projectManagement/project/taskTime/taskTime";
import publicHolidaySlice from "../features/publicHoliday/publicHolidaySlice";
import salaryComponentsSlice from "../features/salaryComponent/salaryComponentSlice";
import setUpSlice from "../features/setUp/setUpSlice";
import shiftSlice from "../features/shift/shiftSlice";
import terminationSlice from "../features/termination/terminationSlice";
import transactionSlice from "../features/transaction/transactionSlice";
import travelSlice from "../features/travel/travelSlice";
import userReducer from "../features/user/userSlice";
import weeklyHolidaySlice from "../features/weeklyHoliday/weeklyHolidaySlice";
import taskHistorySlice from "../features/taskStatusHistory/taskStatusHistorySlice";
import salaryHistorySlice from "../features/salary/salarySlice";
import masterSlice from "../features/masters/masterSlice";
import settingSlice from "../features/settingSlice/settingSlice";
import permissionSlice from "../features/permission/permissionSlice";
import resignationSlice from "../features/resignation/resignationSlice";
import hiringSlice from "../features/hiring/hiringSlice";
import letterTemplateSlice from "../features/letterTemplate/letterTemplateSlice";
import letterTemplateFieldSlice from "../features/letterTemplate/letterTemplateFieldSlice";
import compOffPolicySlice from "../features/compOffPolicy/compOffPolicySlice";

const reduxLogger = require("redux-logger");
const logger = reduxLogger.createLogger();

// const store = configureStore({
const rootReducer = combineReducers({
  // reducer: {
  users: userReducer,
  dashboard: dashboardReducer,
  designations: designationReducer,
  payroll: payrollSlice,
  payment: paymentSlice,
  shift: shiftSlice,
  employmentStatus: employmentStatusSlice,
  attendance: attendanceReducer,
  leave: leaveSlice,
  loan: loanSlice,
  expense: expenseSlice,
  expenseType: expenseTypeSlice,
  advancePayment: advancePaymentSlice,
  accounts: accountSlice,
  transactions: transactionSlice,
  announcement: announcementSlice,
  award: awardSlice,
  awardHistory: awardHistorySlice,
  leavePolicy: leavePolicySlice,
  weeklyHoliday: weeklyHolidaySlice,
  publicHoliday: publicHolidaySlice,
  milestone: milestoneSlice,
  project: projectSlice,
  projectTask: projectTaskSlice,
  notification: notificationSlice,
  projectTeam: projectTeamSlice,
  projectSiteDetails: projectSiteDetailsSlice,
  projectSiteArea: projectSiteAreaSlice,
  projectWBS: projectWBSSlice,
  projectType: projectTypeSlice,
  taskDependency: taskDependencySlice,
  taskStatus: taskStatusSlice,
  taskTime: taskTimeSlice,
  taskPriority: taskPrioritySlice,
  salaryComponents: salaryComponentsSlice,
  linkUser: linkUserSlice,
  document: documentSlice,
  employeeDocument: employeeDocumentSlice,
  AssignedTask: AssignedTaskSlice,
  asset: AssetsSlice,
  setUp: setUpSlice,
  dayPart: dayPartSlice,
  terminationReason: terminationReasonSlice,
  termination: terminationSlice,
  travel: travelSlice,
  expenseProject: expenseProjectSlice,
  taskHistory: taskHistorySlice,
  salaryHistory: salaryHistorySlice,
  masters: masterSlice,
  setting: settingSlice,
  permission: permissionSlice,
  resignation: resignationSlice,
  hiring: hiringSlice,
  letterTemplate: letterTemplateSlice,
  letterTemplateField: letterTemplateFieldSlice,
  compOffPolicy: compOffPolicySlice,
  // },

  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: false,
  //   }),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

// export default store;
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["permission"], // add only reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
